import React, { useMemo } from "react";
import { SbTable } from "uiCore";
import { PlanTableWrapperStyled } from "../ViewPlanningV2.styles";
import { buildPlanColumns } from "../useViewPlanningColumns";
import { tableEmptyLocale } from "../ViewPlanningV2.utils";

// Both tabs' landing view — the saved plans list (name, creator, date, job
// count). `plans` is null while loading, per the page's fetch convention.
// onEdit is only passed by the Redeployment Planning tab.
const PlansListTable = ({ plans, emptyMessage, onOpenPlan, onEdit }) => {
  // Memoized on the rows so the parent page's drill-down state changes
  // don't hand antd a fresh columns identity every render.
  const columns = useMemo(() => buildPlanColumns(plans || [], onEdit), [plans, onEdit]);
  return (
  <PlanTableWrapperStyled>
    <SbTable
      columns={columns}
      dataSource={plans || []}
      loading={plans === null}
      rowKey="plan_id"
      sticky
      onRow={(record) => ({ onClick: () => onOpenPlan(record) })}
      locale={tableEmptyLocale(plans, emptyMessage)}
    />
  </PlanTableWrapperStyled>
  );
};

export default PlansListTable;
